<script>

/**
 * Automodal 
 * 
 * Version 1.2
 * Corrige la actualización desde cArchetype automática de automodal. 
 * (Requiere "UI Edit automodal@1.10")
 * 
 * Version 1.1
 * Se pasa a ui-edit-auto-modal el parámetro :form-id, requerido para el control de borrado.
 * 
 * Version 1.0
 * Placeholder base
 */

import _ from 'lodash'
import md5 from 'js-md5'

import {getArchetype, automodalHandler} from './archetype'

export default {
    name: 'MonederoAutomodal',
    props: {
        predefinedUserId: {
            type: [String, Number]
        },
        conceptId: {
            type: [String, Number],
        }
    },
    data: () => {
        return {
            form: {
                id: null,
                estatus: null
            },
            asides: {
                usuarios: [],
                admins: [],
            }
        }
    },
    computed: {
        formArchetypeMD5(){
			return md5(JSON.stringify(this.cArchetype))
		},
        cArchetype(){
            let updated = [];
            _.forEach(new getArchetype(), itemsRow => {
                if(!_.isArray(itemsRow)){
                    updated.push(itemsRow);
                    return
                } 
                let adding = []
                _.forEach(itemsRow, item => {
                    // EVALUACIÓN DINÁMICA POR ELEMENTO DE ARQUETIPO
                    // NO FUNCIONA ESCONDER ELEMENTOS DENTRO DE ARRAY
                    switch(item.key){
                        case 'usuario_id_pk':
                            item.options = _.clone(this.asides.usuarios)
                            if(!this.form.id && this.predefinedUserId){
                                item.default = this.predefinedUserId
                                item.readonly = true
                            } else if(this.form.id){
                                item.readonly = true
                            }
                            break;
                        case 'cantidad':
                            if(this.form.estatus == "Sin revisión" || !this.form.id){
                                item.readonly = false
                            }
                            break;
                        case 'usuario_id_pk_auditor':
                            item.options = this.asides.admins
                            break;
                        // case 'estatus':
                        //     item.readonly = (this.form.estatus != "Sin revisión")
                        //     break;
                    }
                    adding.push(item)
                })
                updated.push(adding)
            })
            return updated
        }
    },
    methods: {
        getHandler(){
            return automodalHandler(this.conceptId)
        },
        refresh(){
            this.$emit('refresh');
        },
        checkAsides(){
            const asides = this.$refs.automodal.getAsides();
            console.log("asides", asides)
            if(!!asides){
                this.asides.usuarios                        = asides.usuarios
                this.asides.admins                          = asides.admins
            }
        },
        onDisplay(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL HA CARGADO DOM COMPLETAMENTE.
        },
        onHidden(){
            // SE EJECUTA JUSTO EN EL MOMENTO QUE EL MODAL SE HA OCULTADO
        },

    },
    watch: {
        'form.id'(){
            
        }
    }
}
</script>

<template>
    <ui-edit-auto-modal v-model="form"  ref="automodal" size="md" 
        :form-id="form.id" 
        :form-archetype="cArchetype" 
        :handler="getHandler()"  
        :allow-aside="false" 
        :allow-delete="false"
        :form-key="formArchetypeMD5"
        @refresh="refresh()" 
        @defined="checkAsides()" 
        @display="onDisplay" 
        @hidden="onHidden">
        <slot name="default"><i class="fa fa-cog"></i></slot>
        <b-col slot="aside" cols="7">
            <!-- LATERAL, REQUIERE :allow-aside="true" -->
        </b-col>
        <b-col slot="bottom" v-if="false">
            <!-- AGREGAR AL FONDO... -->
        </b-col>
    </ui-edit-auto-modal>
</template>